export default __webpack_public_path__ + "static/media/006-Buddha.8b1448de.svg";